module.exports = __webpack_public_path__ + "static/media/Logo.cb021a11.svg";